import { installDomGuard } from '@/app/domGuard'
import '@/i18n'
import '@/features/preferences/store'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { Providers } from '@/app/Providers'
import { router } from '@/routes/router'
import '@/styles/index.css'

installDomGuard()

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')

createRoot(root).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
)
